import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgWindsurfLogoIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 12c3-1 7-1 10 0-2.5 2-7.5 2-10 0zM4 10c2.5-6 6-8 9-8.5C11 4 9.5 7 8.8 10c-1.6-.3-3.2-.3-4.8 0z", fill: "#0B928F" }));
});
export default SvgWindsurfLogoIcon;
